import { createStand } from '##/stand/standConfig';

export default createStand({
  title: 'Быстрый старт',
  id: 'start',
  group: 'docs',
  order: 10,
});
